import { useHRPortalConfig } from '@openeducation/hr-rn-components';
import { hrPortalConfigAtom } from '@openeducation/hr-rn-jotai-atoms';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { getOrganizationByPath, useLocation } from '../router';

export const useSetHRPortalConfig = () => {
  const location = useLocation();
  const organization = getOrganizationByPath(location.pathname);
  const hrPortalConfig = useHRPortalConfig(organization);
  const setHRPortalConfig = useSetAtom(hrPortalConfigAtom);

  useEffect(() => {
    if (hrPortalConfig && organization) {
      setHRPortalConfig(hrPortalConfig);
    }
  }, [hrPortalConfig, setHRPortalConfig, organization]);
};
